import { MORTGAGE_STATE } from '../../components/mortgage-calculator/shared';
import type { MortgageCalculators } from '../../components/mortgage-calculator/shared/types';

/**
 * Function to redirect when user clicks/interacts with the page.
 *
 * @param {string} mortgageCalculator
 * @param {Object} location
 * @param {Object} history
 */
export const mortgageCalculatorsRedirect = (
  mortgageCalculator: MortgageCalculators,
  location: Record<string, any>,
  history: Record<string, any>
): void => {
  let newLocation = '';

  if (location?.pathname?.indexOf('calculate-mortgage-payment') !== -1) {
    return;
  }

  if (mortgageCalculator === MORTGAGE_STATE) {
    const newPathname = location.pathname.split('/');
    // Prepending this per product request but keep the utm params
    newPathname.splice(3, 0, 'calculate-mortgage-payment');
    newLocation = `${newPathname.join('/')}${location.search}${location.hash}`;
  } else {
    newLocation = `${location?.pathname}/calculate-mortgage-payment${location?.search}${location?.hash}`;
  }
  history?.pushState(
    {
      postOnboarding: true,
    },
    newLocation
  );
};
